import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CallIcon from '@mui/icons-material/Call';
import PhoneIcon from '@mui/icons-material/Phone';

import { BrokerOutlinedIcon } from './Broker';
import { BrokerCallIcon } from './BrokerCall';
import { CalendarAppointmentIcon } from './CalendarAppointment';
import { CalendarFullIcon } from './CalendarFull';
import { CalendarOutlinedIcon } from './CalendarOutlined';
import { CallOutlinedIcon } from './Call';
import { CheckBoxIcon } from './CheckBox';
import { CheckBoxCheckedIcon } from './CheckBoxChecked';
import { EuroIcon } from './Euro';
import { LocationIcon } from './Location';
import { LongArrowNextIcon } from './LongArrowNext';
import { LongArrowPrevIcon } from './LongArrowPrev';
import { ClockIcon } from './Clock';
import { AppointmentTypeCall } from './AppointmentTypeCall';
import { AppointmentTypeOnsite } from './AppointmentTypeOnsite';
// {generated-icon-import-placeholder}

export const icons = {
  'long-arrow-next': LongArrowNextIcon,
  'long-arrow-prev': LongArrowPrevIcon,
  'check-box': CheckBoxIcon,
  'check-box-checked': CheckBoxCheckedIcon,
  'broker-call': BrokerCallIcon,
  'calendar-today': CalendarTodayIcon,
  'calendar-full': CalendarFullIcon,
  'calendar-appointment': CalendarAppointmentIcon,
  'calendar-outlined': CalendarOutlinedIcon,
  call: CallIcon,
  euro: EuroIcon,
  phone: PhoneIcon,
  location: LocationIcon,
  'broker-outlined': BrokerOutlinedIcon,
  'call-outlined': CallOutlinedIcon,
  clock: ClockIcon,
  AppointmentTypeCall,
  AppointmentTypeOnsite,
};

export type IconName = keyof typeof icons;
